import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const building = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/building/index.js